import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 3: Centralny z emoji - bardzo ciepły, spokojny vibe
 */
export const InstagramStoryShare3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      {/* Background image */}
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Subtle top accent */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "6px",
          background: "#4E8A6E",
          zIndex: 2,
        }}
      />

      {/* Content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "280px 100px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Large emoji */}
        <span
          style={{
            fontSize: "140px",
            marginBottom: "48px",
          }}
        >
          💚
        </span>

        {/* Main headline */}
        <h1
          style={{
            fontSize: "84px",
            fontWeight: 800,
            color: "#2D5A3D",
            margin: "0 0 48px",
            textAlign: "center",
            lineHeight: 1.15,
          }}
        >
          Udostępnienie
          <br />
          też pomaga
        </h1>

        {/* Divider line */}
        <div
          style={{
            width: "120px",
            height: "6px",
            background: "#4E8A6E",
            borderRadius: "3px",
            marginBottom: "48px",
          }}
        />

        {/* Subtext */}
        <p
          style={{
            fontSize: "42px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "0 0 40px",
            textAlign: "center",
            lineHeight: 1.5,
          }}
        >
          Może ktoś z Twoich znajomych
          <br />
          chce pomóc, tylko nie wie jak.
        </p>

        {/* Community text in pill */}
        <div
          style={{
            background: "rgba(78, 138, 110, 0.12)",
            borderRadius: "24px",
            padding: "28px 48px",
            marginBottom: "64px",
          }}
        >
          <p
            style={{
              fontSize: "34px",
              fontWeight: 700,
              color: "#3D6B52",
              margin: 0,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Zbudujmy razem społeczność
            <br />
            pomagającą schroniskom
          </p>
        </div>

        {/* CTA */}
        <p
          style={{
            fontSize: "36px",
            fontWeight: 700,
            color: "#4E8A6E",
            margin: 0,
            textAlign: "center",
          }}
        >
          ↑ Udostępnij dalej ↑
        </p>
      </div>

      {/* Footer */}
      <div
        style={{
          padding: "0 80px 120px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "52px",
              height: "52px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
        <span style={{ fontSize: "26px", fontWeight: 600, color: "#6B8A7A" }}>
          gdzieschronisko.pl
        </span>
      </div>
    </div>
  );
};
